import React from 'react';

export default class Table extends React.Component {
    render() {
        return (
            <table className="table is-fullwidth">
                <thead>
                    <tr>
                        <th>Nombre de usuario</th>
                        <th>Contraseña</th>
                        <th>Pin</th>
                        <th>Role</th>
                    </tr>
                </thead>
                    {this.props.users.map((user) => (
                        <tbody key={user._id}>
                            <tr>
                                <td>{user.userName}</td>
                                <td>{user.password}</td>
                                <td>{user.pin}</td>
                                <td>{user.role}</td>
                            </tr>
                        </tbody>
                    ))}
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/add-json/components/table/index.js